import { CalendarPlusIcon } from '@phosphor-icons/react';

import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const AddCalender = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return <CalendarPlusIcon size={Sizes[size]} {...rest} color={fill} />;
};

AddCalender.displayName = 'AddCalender';
